import { createAction, props } from '@ngrx/store';
import { type } from '@app/util/util';
import { SearchData } from '@shared/base-search-bar/entities/search-data';
import { TravelerPaxResponse } from '@pax/entities/traveler-pax';
import { User } from '@app/modules/core/interfaces/user';
import { TravelerInfoType } from '@pax/entities/traveler-info';
import { SearchBy } from '@shared/base-search-bar/entities/search.entities';

export const saveSearchDataAction = createAction(
  type('[SearchBar/Data] Save Search data'),
  props<{ data: SearchData, searchBy: SearchBy }>()
);
export const loadSearchDataAction = createAction(
  type('[SearchBar/Data] Load search data'),
  props<{ searchBy: SearchBy }>()
);
export const loadSearchDataSuccessAction = createAction(
  type('[SearchBar/Data] Load search data success'),
  props<{ data: SearchData, searchBy: SearchBy, exchange?: boolean }>()
);
export const loadSearchBookingDataAction = createAction(
  type('[Booking/SearchData] Load booking search data'),
  props<{ response: TravelerPaxResponse[], user: User, travelerInfoType: TravelerInfoType }>()
);
export const saveExchangeSearchDataAction = createAction(type('[Booking/SearchData] Save exchange search data'),
  props<{ data: SearchData }>());
export const resetAlertsDataAction = createAction(type('[SearchBar/Data] Reset alerts data'));
